// extracted by mini-css-extract-plugin
module.exports = {"indent":"_1rWgIj","tableRow":"_2o9g83","tableSubRow":"_3YU2wv","right":"_1qTIEW","tableHeading":"_2zQftH"};